import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

/**
 * @param {Object} props
 * @param {import('utils/types').Size} [props.size]
 * @param {import('utils/types').Shade} [props.shade]
 * @param {string} [props.className]
 */
export default function Spinner({ size = 'md', shade = 400, className = '' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      data-size={size}
      className={styles.icon}
    >
      <g
        fill={`var(--gray-${shade})`}
        className={cn(styles.spinner, className)}
      >
        <circle cx={3} cy={12} r={1.5} />
        <circle cx={21} cy={12} r={1.5} />
        <circle cx={12} cy={21} r={1.5} />
        <circle cx={12} cy={3} r={1.5} />
        <circle cx={5.64} cy={5.64} r={1.5} />
        <circle cx={18.36} cy={18.36} r={1.5} />
        <circle cx={5.64} cy={18.36} r={1.5} />
        {/* <circle cx={18.36} cy={5.64} r={2} /> */}
      </g>
    </svg>
  );
}
